// Tables for a spreadsheet: the options compared, and every flat of one.
// Semicolons and decimal commas, because that is what a Romanian Excel
// opens without an import dialog.
import type { ProForma } from "../finance.ts";
import type { Generated } from "../generate.ts";

const num = (n: number, dp = 2) => n.toFixed(dp).replace(".", ",");
const cell = (v: string | number) => (typeof v === "number" ? num(v) : /[;"\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);
const table = (rows: (string | number)[][]) => "﻿" + rows.map((r) => r.map(cell).join(";")).join("\r\n") + "\r\n";

export function optionsCsv(opts: { g: Generated; pf: ProForma }[], plotArea: number): string {
  return table([
    ["Variantă", "Regim", "Apartamente", "Garsoniere", "2 cam.", "3 cam.", "4 cam.", "Adc m²", "Utilă m²", "POT %", "CUT", "Însorite", "Locuri parcare", "Subsoluri", "Venit €", "Cost €", "Profit €", "Marjă %"],
    ...opts.map(({ g, pf }) => {
      const by = (t: string) => g.dwellings.byType.find((b) => b.type === t)?.count ?? 0;
      return [g.option.id, `P+${g.option.storeys.length - 1}E`, g.dwellings.total, by("1"), by("2"), by("3"), by("4"),
        g.option.grossArea, g.dwellings.usable, g.indicators.pot, g.indicators.cut, g.layout.total - g.layout.sunless,
        g.parking.capacity, g.parking.levels, pf.revenue.total, pf.cost.total, pf.profit, pf.margin * 100];
    }),
    [],
    ["Teren m²", plotArea],
  ]);
}

export function flatsCsv(g: Generated): string {
  const rows: (string | number)[][] = [["Nivel", "Apartament", "Tip (camere)", "Suprafață construită m²", "Utilă m²", "Balcon m²", "Ore soare 21 dec.", "Front la fațadă m"]];
  for (const f of g.layout.floors) for (const u of f.units) {
    if (u.kind !== "apartment") continue;
    const balcony = u.balcony ? u.balcony.flatMap((p) => p).reduce((t, ring) => t + Math.abs(ring.reduce((s, p, i) => s + p[0] * ring[(i + 1) % ring.length][1] - ring[(i + 1) % ring.length][0] * p[1], 0) / 2), 0) : 0;
    rows.push([f.index === 0 ? "P" : `E${f.index}`, u.id, u.type ?? "", u.area, u.usable ?? 0, balcony, u.sunHours ?? 0, u.frontage ?? 0]);
  }
  return table(rows);
}
